import React, { Fragment, useEffect, useState } from "react";
// import FadeIn from "react-fade-in/lib/FadeIn";
import {
    Button, Col, Form, FormGroup, Input, Label, Row, Table, Modal, ModalHeader, ModalFooter, Toast, ToastBody
} from "reactstrap";
import { GetCookieToken } from "../../Cookie/GetCookie";
import { FetchAxiosPost, FetchAxiosGet } from "../../../api/axios";
// import LoadingPage from "../../TESTPage/LoadingPage";
import Select from 'react-select';
import axios from "axios";
import MyDatePicker from "../../../components/Common/MyDateTimePicker";
import NewThaiDatePicker from "../../../components/Common/NewThaiDatePicker";

const API_URL = process.env.REACT_APP_API_CORS;
const userToken = GetCookieToken("userToken");

function PersonalTimeEntryExitGroup() {

    const [usersOptions, setUsersOptions] = useState([]);
    const [dateEntryExit, setDateEntryExit] = useState(null);
    const [timeEntry, setTimeEntry] = useState(null);
    const [timeExit, setTimeExit] = useState(null);
    const [user, setUser] = useState(null);
    const [submit, setSubmit] = useState(false);
    const [modal, setModal] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [successAdd, setSuccessAdd] = useState(false);
    const [loading, setLoading] = useState(false);
    const [userHistory, setUserHistory] = useState({ entry: {}, exit: {} });
    const [conditonMessage, setConditonMessage] = useState(false);

    const fetchData = () => {
        setConditonMessage(true)
        let options = [];
        const url = `${API_URL}/api/users/datatable`;
        const params = new URLSearchParams({
            page: 1,
            size: 1000,
            "order[0]": "user_name",
            "order[1]": "ASC",
            "filter[deleted][0]": "1",
            "filter[user_name_status][0]": "ปกติ",
        });
        const config = { headers: { Authorization: `Bearer ${userToken}` }, params };
        axios.get(url, config).then(response => {
            response.data.result.map(x => options.push({ value: x.user_id, label: x.user_name }));
            setUsersOptions(options);
            setConditonMessage(false)
        }).catch(error => console.error("Error:", error));
    };

    useEffect(() => { fetchData(); }, []);

    const saveTimeEntryExit = async () => {
        try {
            setDisabled(true);
            let baseURL = API_URL + `/api/time/entryExitUser`;
            const config = {
                headers: {
                    Authorization: `Bearer ${userToken}`,
                },
            };
            let response = await axios.post(baseURL, { user_id: user, dateEntryExit: dateEntryExit, timeEntry: timeEntry, timeExit: timeExit }, config);
            if (response) {
                setModal(false);
                thisUseEffect();
                // setDateEntryExit('');
                // setTimeEntry('');
                // setTimeExit('');
            }
            setDisabled(false);
            setSuccessAdd(true);
        } catch (error) {
            setDisabled(false);
        }
    }

    let thisUseEffect = async () => {
        setLoading(true);
        if (dateEntryExit && user) {
            const params = new URLSearchParams({
                page: 1,
                size: 1000,
                "filter[user_id][0]": user,
                "order[0]": "scan_date",
                "order[1]": "DESC",
                date_start: dateEntryExit,
                date_end: dateEntryExit,
            });
            let baseURL = API_URL + `/api/time/history`;
            const config = {
                headers: {
                    Authorization: `Bearer ${userToken}`,
                }, params
            };
            let { data } = await axios.get(baseURL, config);
            let history = data.result;
            let entry = history.find(x => x.entry_exit_status === 0);
            let exit = history.find(x => x.entry_exit_status === 1);
            let dataSet = {
                entry: entry?.scan_date ? `${entry?.scan_date}`.split("T")[1].split(".")[0] : null,
                exit: exit?.scan_date ? `${exit?.scan_date}`.split("T")[1].split(".")[0] : null
            }
            setUserHistory(dataSet);
            setTimeEntry(dataSet?.entry || '');
            setTimeExit(dataSet?.exit || '');
            setLoading(false);

        } else { setLoading(false); }
    }

    useEffect(() => {
        setSuccessAdd(false);
        thisUseEffect();
    }, [dateEntryExit, user]);

    return (
        <Fragment>
            <Modal backdrop={'static'} isOpen={modal} toggle={() => { setModal(false) }} size="sm" centered={true}>
                <ModalHeader toggle={() => { setModal(false) }}>
                    ต้องการลงเวลาเข้าออกงานใช่หรือไม่ ?
                </ModalHeader>

                <ModalFooter>
                    <Button color="success" onClick={saveTimeEntryExit} disabled={disabled}>
                        {disabled ? <i class="fa-solid fa-floppy-disk pe-2 fa-fade"></i> : <i class="fa-solid fa-floppy-disk pe-2"></i>}บันทึก
                    </Button>{' '}
                    <Button color="danger" onClick={() => { setModal(false) }} disabled={disabled}>
                        <i class="fa-solid fa-xmark pe-2"></i>ยกเลิก
                    </Button>
                </ModalFooter>
            </Modal>
            <Toast className="align-items-center text-white bg-success border-0 mb-2 shadow-none"
                isOpen={successAdd} role="alert" aria-label="assertive" aria-atomic={true} >
                <ToastBody className="d-flex">
                    <i class="fa-solid fa-circle-check m-0 mt-1 me-2"></i>
                    บันทึกสำเร็จ
                    <button onClick={() => setSuccessAdd(false)} type="button" class="btn-close btn-close-white me-0 m-auto" />
                </ToastBody>
            </Toast>
            <Form
                className={submit ? 'was-validated' : ''}
                noValidate
                onSubmit={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setSubmit(true);
                    if (user && dateEntryExit) { setModal(true); }
                }}
            >
                <Row>
                    <Col lg={12}>
                        <FormGroup>
                            <Label className="text-danger">* เจ้าหน้าที่</Label>
                            {usersOptions ? <Select
                                className="basic-single"
                                classNamePrefix="เจ้าหน้าที่"
                                defaultValue='0'
                                isSearchable={true}
                                placeholder='เจ้าหน้าที่...'
                                options={usersOptions}
                                required={true}
                                noOptionsMessage={()=>conditonMessage ? "กำลังดาวน์โหลดข้อมูล..." : "ไม่พบรายชื่อเจ้าหน้าที่ดังกล่าว"}
                                // loadingMessage={()=>"กำลังดาวน์โหลดข้อมูล"}
                                onChange={e => { setUser(e?.value) }}
                            /> : <h5><i class="fa-duotone fa-spinner-third fa-spin"></i></h5>}
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col lg={12}>
                        <FormGroup>
                            <Label>ลงเวลาเข้าออกงาน</Label>
                            <Table className="table table-bordered table-hover" responsive>
                                <thead className="table-light table-nowrap">
                                    <tr>
                                        <th className="p-2 py-1 text-nowrap text-danger w-25">* วันที่</th>
                                        <th className="p-2 py-1 text-nowrap w-25" >เวลาเข้างาน</th>
                                        <th className="p-2 py-1 text-nowrap w-25" >เวลาออกงาน</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            {/* <Input name="dateEntryExit" id="dateEntryExit" value={dateEntryExit} type="date" placeholder="เลือกวันที่ ..." required={true}
                                                disabled={loading}
                                                onChange={(e) => { setDateEntryExit(e?.target.value) }}
                                            /> */}
                                            <NewThaiDatePicker name ={"dateEntryExit"} value={dateEntryExit} setValue={setDateEntryExit} placeholderText = "วัน/เดือน/ปี"/>
                                            {submit && !dateEntryExit ? <div style={{ color: 'red' }}>กรุณาเลือกวันที่</div> : ""}
                                            <div className='pt-1' >
                                                {loading ? <i className="fa-duotone fa-spinner-third fa-spin"></i> : ''}
                                                {!loading && !userHistory?.entry && !userHistory?.exit ? <b className="text-primary"><i class="fa-solid fa-square-info pe-1"></i>ไม่พบข้อมูลเข้าออกงานในวันนี้</b> : ''}
                                            </div>
                                        </td>
                                        <td>
                                            <Input name="timeEntry" id="timeEntry" value={timeEntry} type="time" step="1" placeholder="เลือกวันที่ ..."
                                                disabled={loading}
                                                onChange={(e) => { setTimeEntry(e?.target.value) }}
                                            />
                                            <div className='pt-1' >
                                                {!timeEntry || timeEntry === '00:00:00' ? <b className="text-primary"><i class="fa-solid fa-square-info pe-1"></i>ถ้าลบเวลาเข้างานระบบจะลบเวลาออกงานด้วย</b> : ''}
                                            </div>
                                        </td>
                                        <td>
                                            <Input name="timeExit" id="timeExit" value={timeExit} type="time" step="1" placeholder="เลือกวันที่ ..."
                                                disabled={loading}
                                                onChange={(e) => { setTimeExit(e?.target.value) }}
                                            />
                                            <div className='pt-1' >

                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col lg={11}></Col>
                    <Col lg={1} className="text-end">
                        <Button className="text-nowrap" color="success" type="submit"
                            disabled={!userHistory?.entry && !userHistory?.exit && !timeEntry && !timeExit ? true : false}>
                            <i class="fa-solid fa-floppy-disk pe-2"></i>บันทึก
                        </Button>
                    </Col>
                </Row>
            </Form>
        </Fragment >
    );
}

export default PersonalTimeEntryExitGroup;
